import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIndexSliders } from '../../../../../redux/actions/sliders'
import { IRootState } from '../../../../../redux/types'
import { HomeLink } from '../../models/sliders'

export const useSliderClient = () => {
  const dispatch = useDispatch()
  const { sliders, homeLinks, loading } = useSelector((state: IRootState) => state.slider)
  const { globalCountryId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  const [open, setOpen] = useState(false)
  const [sliderSelected, setSliderSelected] = useState({ id: null })

  const [topHomeLink, setTopHomeLink] = useState<HomeLink | null>(null)
  const [downLeftHomeLink, setDownLeftHomeLink] = useState<HomeLink | null>(null)
  const [downRightHomeLink, setDownRightHomeLink] = useState<HomeLink | null>(null)

  const findLinkByOrder = (links: HomeLink[], order: number): HomeLink | undefined => {
    return links.find((link: HomeLink) => link.order === order)
  }

  const organizeHomeLinks = (links: HomeLink[]) => {
    if (!links || links.length === 0) {
      setTopHomeLink(null)
      setDownLeftHomeLink(null)
      setDownRightHomeLink(null)
      return
    }

    const link1 = findLinkByOrder(links, 1)
    const link2 = findLinkByOrder(links, 2)
    const link3 = findLinkByOrder(links, 3)

    if (link1) {
      setTopHomeLink(link1)
      setDownLeftHomeLink(link2 || null)
      setDownRightHomeLink(link3 || null)
    } else if (link2) {
      setTopHomeLink(link2)
      setDownLeftHomeLink(link3 || null)
      setDownRightHomeLink(null)
    } else if (link3) {
      setTopHomeLink(link3)
      setDownLeftHomeLink(null)
      setDownRightHomeLink(null)
    } else {
      setTopHomeLink(null)
      setDownLeftHomeLink(null)
      setDownRightHomeLink(null)
    }
  }

  const handleClickItem = (item: any) => {
    if (item.type === 0) {
      window.open(item.value, '_blank', 'noopener,noreferrer')
    } else if (item.type === 1) {
      setOpen(!open)
      setSliderSelected(item)
    }
  }

  const getMobileLinks = () => {
    return [topHomeLink, downLeftHomeLink, downRightHomeLink].filter(Boolean) as HomeLink[]
  }

  useEffect(() => {
    organizeHomeLinks(homeLinks)
  }, [homeLinks])

  useEffect(() => {
    if (globalCountryId !== null && globalLanguageId !== null) {
      dispatch(
        getIndexSliders({
          country_id: globalCountryId,
          language_id: globalLanguageId
        })
      )
    }

    setTopHomeLink(null)
    setDownLeftHomeLink(null)
    setDownRightHomeLink(null)
  }, [globalCountryId, globalLanguageId, dispatch])

  return {
    sliders,
    loading,
    open,
    setOpen,
    sliderSelected,
    topHomeLink,
    downLeftHomeLink,
    downRightHomeLink,
    handleClickItem,
    getMobileLinks
  }
}
